import { AppSettings } from './../../app.settings';
import { UiService } from './../../services/ui.service';
import { UserCommonService } from './../../services/user-common.service';
import { UntypedFormGroup, UntypedFormControl, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-otp-verifiy',
  templateUrl: './otp-verifiy.component.html'
})
export class OtpVerifiyComponent implements OnInit {
  @Input() email;
  @Input() phone;

  @Output() onOtpPopClose: EventEmitter<any> = new EventEmitter();
  @Output() onOtpPopSave: EventEmitter<any> = new EventEmitter();

  isSubmitting = false;
  otpForm = new UntypedFormGroup({
    otpInput: new UntypedFormControl()
  });

  constructor(
    private formBuilder: FormBuilder,
    private commonServices: UserCommonService,
    private uiService: UiService,
  ) { }

  ngOnInit() {
    this.otpForm = this.formBuilder.group({
      otpInput: ['', [Validators.required]],
    });
  }

  closeEditForgot(event) {
    if (this.isSubmitting) {
      return;
    }
    this.otpForm.reset();
    this.onOtpPopClose.emit();
  }

  changePassword(event) {
    if (this.isSubmitting || this.otpForm.invalid) {
      this.otpForm.markAllAsTouched();
      return;
    }

    const input = {
      otp: this.otpForm.controls.otpInput.value,
      email: this.email
    };

    this.isSubmitting = true;
    this.commonServices.validateOtp(JSON.stringify(input)).subscribe(results => {
      this.isSubmitting = false;
      this.onOtpPopSave.emit(results);
      this.otpForm.reset();
    }, (error) => {
      this.isSubmitting = false;
      this.showErrorToast(error);
    });
  }

  private showErrorToast(error) {
    const message = this.getApiErrorMessage(error);
    if (message) {
      this.uiService.showMessage(message, AppSettings.MESSAGE_TYPE.ERROR);
    }
  }

  private getApiErrorMessage(error): string {
    if (!error) {
      return '';
    }
    for (const key of Object.keys(error)) {
      if (Array.isArray(error[key]) && error[key][0]?.message) {
        return error[key][0].message;
      }
    }
    return '';
  }
}
